export default function encodeURI(url) {
    return encodeURIComponent(url.trim().replace(/[\s\/]+/g, '-'));

}